export { default } from './StuiSubHeading'
